import * as SHARED from "../../../utils/shared";

/**
 * UserCard
 * @param {String} title
 * @param {String} subTitle
 * @param {String} state
 * @returns
 */
function UserCard(props) {
  const { title = "", subTitle = "", state = "", image = "" } = props;

  const ESTADOS_CONSTANCIAS = {
    [SHARED.ID_ESTADO_NO_INSCRITO]: "bg-gray-200",
    [SHARED.ID_ESTADO_SORTEADO]: "bg-indigo-500 text-white",
    [SHARED.ID_ESTADO_VALIDADO]: "bg-green-400 text-white",
    [SHARED.ID_ESTADO_PENDIENTE]: "bg-blue-400 text-white",
    [SHARED.ID_ESTADO_OBSERVADO]: "bg-red-400 text-white"
  };

  const TEXT_ESTADOS_CONSTANCIAS = {
    [SHARED.ID_ESTADO_NO_INSCRITO]: "NO INSCRITO",
    [SHARED.ID_ESTADO_SORTEADO]: "SORTEADO",
    [SHARED.ID_ESTADO_VALIDADO]: "VALIDADO",
    [SHARED.ID_ESTADO_PENDIENTE]: "PENDIENTE",
    [SHARED.ID_ESTADO_OBSERVADO]: "OBSERVADO"
  };

  const bg_color = ESTADOS_CONSTANCIAS[state] || "bg-white";

  return (
    <div className="flex flex-col items-center bg-white sm:max-w-full max-w-md rounded overflow-hidden shadow-lg">
      <img className="rounded" src={image} alt={`Foto ${title}`} width={64} height={70} />
      <div className="flex flex-col items-center text-center pt-1 pb-6">
        <p className="py-2 text-lg font-semibold">{title}</p>
        <p className="text-sm text-gray-600">DNI: {subTitle}</p>

        {state && (
          <div className="mt-5">
            <p className={`border rounded-full py-2 px-8 text-xs ${bg_color} font-semibold`}>
              {TEXT_ESTADOS_CONSTANCIAS[state] || "ESTADO NO ENCONTRADO"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserCard;
